var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.35 3.75H7.5v-1.8a.7.7 0 1 0-1.4 0v1.8H5a2.5 2.5 0 0 0-2.5 2.5V15A2.5 2.5 0 0 0 5 17.5h10a2.5 2.5 0 0 0 2.5-2.5V6.25a2.5 2.5 0 0 0-2.5-2.5h-1.25v-1.8a.7.7 0 1 0-1.4 0zM5 5.15h10a1.1 1.1 0 0 1 1.1 1.1V15a1.1 1.1 0 0 1-1.1 1.1H5A1.1 1.1 0 0 1 3.9 15V6.25A1.1 1.1 0 0 1 5 5.15M6.25 8.6a.7.7 0 1 0 0 1.4h7.5a.7.7 0 1 0 0-1.4z",
    clipRule: "evenodd"
  })));
};
export default SvgCalendar;